import { createFileRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import { IconChartBar } from '@tabler/icons-react';
import { MaeShell, MaePageHead } from '@/shared/desktop/MaeShell';
import { ViewSelector } from '@/shared/components/SelettoreVista';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { ChromeSlotsContext } from '@/features/timesheet/desktop/chromeSlotsContext';
/* L'elenco delle viste è condiviso con la striscia mobile: era dichiarato qui, e la shell
   mobile — che queste tab non le rende — se l'era ricopiato nel menu laterale. */
import { TIMESHEET_SECTIONS, activeSection } from '@/features/timesheet/sezioni';

export const Route = createFileRoute('/_app/timesheet')({ component: TimesheetLayoutSelector });

/** Su mobile niente chrome desktop (tab/header): la schermata mobile ha il proprio header. */
function TimesheetLayoutSelector() {
  const isMobile = useIsMobileShell();
  return isMobile ? <Outlet /> : <TimesheetLayout />;
}

function TimesheetLayout() {
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const activeTab = activeSection(path);
  /* Solo il mese riempie la finestra: le altre sezioni scorrono con la pagina. */
  const fillsWindow = activeTab.value === 'entries';
  const [viewsSlot, setViewsSlot] = useState<HTMLDivElement | null>(null);
  const slots = useMemo(() => ({ views: viewsSlot }), [viewsSlot]);
  const sections = useMemo(
    () => TIMESHEET_SECTIONS.map((t) => ({ ...t, icon: <t.icon size={16} /> })),
    [],
  );

  return (
    <MaeShell fullHeight={fillsWindow}>
      <ChromeSlotsContext.Provider value={slots}>
        <MaePageHead
          title="Rendicontazione"
          sub={activeTab.sub}
          icon={<IconChartBar size={22} />}
        />
        {/* Stesso selettore della pagina task; a destra il cambio vista della sezione aperta. */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
          <ViewSelector
            views={sections}
            active={activeTab.value}
            onChange={(v) => void navigate({ to: v.path })}
            groupLabel="Sezioni della rendicontazione"
          />
          <div ref={setViewsSlot} style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }} />
        </div>
        {fillsWindow ? <div style={{ flex: 1, minHeight: 0 }}><Outlet /></div> : <Outlet />}
      </ChromeSlotsContext.Provider>
    </MaeShell>
  );
}
